module.exports = __webpack_public_path__ + "static/media/activity4.ef141785.jpeg";